<template>
    <div>
        <div id="topbar" class="bar"></div>
        <div class="freeback" v-show="freebackShow">
            <div class="freebackText">对吉林一号遥感影像套件有更多建议和期许？快告诉我们吧！ <span style="cursor: pointer;" @click="$router.push('/Feedback');">点击反馈 ></span></div>
            <div class="freebackBlue" id="freebackBlueId">
                <img src="~@/assets/newHome/反馈关闭.png" alt="" class="freebackClose" @click="freebackShow=false">
            </div>
        </div>
        <div class="navi">
            <div class="naviContent" id="naviContentId"><span @click="$router.push('/');" style="cursor: pointer;">首页</span> / <span @click="$router.push('/MyRSservice');" style="cursor: pointer;">我的套件</span> / 套件管理</div>
        </div>
        <div class="greyBasis" id="greyBasisId">
            <!-- 兼容以前的企业版 --> 
            <span v-if="itemList.type=='1'">
                <img src="~@/assets/newHome/all_year.png" alt="" class="basisTitle" v-if="itemList.repSubNam.includes('全年')">
                <img src="~@/assets/newHome/Q1.png" alt="" class="basisTitle" v-if="itemList.repSubNam.includes('一')">
                <img src="~@/assets/newHome/Q2.png" alt="" class="basisTitle" v-if="itemList.repSubNam.includes('二')">
                <img src="~@/assets/newHome/Q3.png" alt="" class="basisTitle" v-if="itemList.repSubNam.includes('三')">
                <img src="~@/assets/newHome/Q4.png" alt="" class="basisTitle" v-if="itemList.repSubNam.includes('四')">
                <div class="basisText1" style="color: #fff;font-weight: 400;">企业版-{{itemList.repSubNam}}</div>
            </span>
            <span v-if="itemList.type=='0'">
                <img src="~@/assets/newHome/体验版.png" alt="" class="basisTitle">
                 <div class="basisText1">体验版</div>
            </span>
            <span v-if="itemList.type=='4'">
                <img src="~@/assets/newHome/Q4.png" alt="" class="basisTitle">
                <div class="basisText1" style="color: #fff;font-weight: 400;">专业版-{{$store.state.subName}}</div>
            </span>
          <span v-if="itemList.type=='5'">
                <img src="~@/assets/newHome/standardTitle.png" alt="" class="basisTitle">
                <div class="basisText1" style="color: #fff;font-weight: 400;">{{itemList.repName}}</div>
            </span>
            <div class="greyContent">
                <div class="keyManage">
                    <div class="keyLine1"></div>
                    <div class="keyLine2"></div>
                    <img src="~@/assets/newHome/我的Key管理.png" alt="" class="keyIcon1">
                    <div class="keyTitle">我的Key 管理</div>
                    <img src="~@/assets/newHome/收起详情.png" alt="" class="keyIcon4" v-if="showKey==0" @click="showKey=1">
                    <img src="~@/assets/newHome/展开详情.png" alt="" class="keyIcon4" v-if="showKey==1" @click="showKey=0">
                </div>
                <div v-if="showKey==0">
                    <div class="greyList" style="height: auto;" id="greyListId">
                        <div class="greyListBlock">
                            <div class="greyListText1" style="right: 451px;top: 0;">
                              <span v-if="itemList.type=='5'">
                                {{itemList.repName}}
                              </span>
                              <span v-else>
                                {{tkName}}
                              </span>
                              <span style="color: #1E81EB;">TK</span>
                            </div>
                            <div class="gretListLine" style="left: 178px;top: -3px;"></div>
                            <div class="greyListText" style="top: 0;left: 208px;">{{ tk }}</div>
                        </div>
                        <div v-for="(item, index) in tkList" :key="index" v-show="tkList.length!=0">
                            <div :class="index==0 ? 'greyListText-s':'greyListText-s1'" >
                                <div class="greyListText1-s">{{ tkList[index].keyList[0].content }}</div>
                                <div class="greyListLine"></div>
                                <div class="greyListText2-s">{{ timeList[index] }}申请</div>
                            </div>
                        </div>
                        <img src="~@/assets/newHome/复制key.png" alt="" class="keyIcon2" id="keyIconId" title="复制" @click="copy()" data-clipboard-action="copy" :data-clipboard-text="tk">
                        <img src="~@/assets/newHome/重新申请key.png" alt="" class="keyIcon2"  title="更改TK" style="right: 99px;top: 18px;z-index: 100;" @click="isShadow=1;daojishiOn()" v-if="itemList.type!='0'">
                        <img src="~@/assets/newHome/查看key.png" alt="" class="keyIcon2" style="right: 15px;top: 22px;" @click="oldKey=0" v-if="oldKey==1&&itemList.type!='0'">
                    </div>
                    <div v-for="(item, index) in mkList" :key="index">
                        <div :class="index==mkList.length-1 ? 'greyList-s' : 'greyList'"  style="margin-bottom: 10px;" v-if="!item.content.includes('预计')">
                            <div class="greyListText1">{{item.name}}  <span style="color: #1E81EB;">MK</span></div>
                            <div class="gretListLine"></div>
                            <div class="greyListText">{{item.content}}</div>
                            <img src="~@/assets/newHome/查看图源.png" alt="" title="查看" :class="`${!/(2024年)|(区县)/.test(item.name)?'keyIcon2':'keyIcon2'}`" v-if="item.type=='mk'" style="top: 22px;" @click="initMap(item.name,`${tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=${item.content}&tk=${tk}&vf=0`,item.extent,item.content)">
                            <img src="~@/assets/newHome/复制key.png" alt="" title="复制" :class="`${!/(2024年)|(区县)/.test(item.name)?'keyIcon3':'keyIcon3'}`" v-if="item.type=='mk'" @click="showCopyPanel(item.content,item.name)" >
                            <span v-if="item.proList">
                              <img v-if="item.type=='mk'&&item.proList.length>0&&closeMkPro.indexOf(item.content)!==-1" @click="addCloseMkPro(item.content)" src="~@/assets/newHome/向上收起.png" alt="" title="收起" class="keyIcon5"  >
                              <img v-if="item.type=='mk'&&item.proList.length>0&&closeMkPro.indexOf(item.content)==-1" @click="decCloseMkPro(item.content)" src="~@/assets/newHome/向下展开.png" alt="" title="展开" class="keyIcon5"  >
                            </span>
                            <img name='卷帘' src="~@/assets/RSsserviceManage/对比.png" class="keyIcon_compare" v-if="!/(全国)|(区县)|(全球)/.test(item.name)" title="对比" @click="juanlian(item)" id="qbMainMap">
                            <img src="~@/assets/newHome/查看使用指导.png" alt="" title="查看使用指导" class="keyIcon2" v-if="item.type!='mk'" style="top: 22px;width: 18px;height: 18px;" @click="yuedushuoming()">
                            <img src="~@/assets/newHome/我的项目.png" alt="" title="我的项目" class="keyIcon2" v-if="item.type!='mk'" style="top: 22px;width: 18px;height: 18px;right: 16px;" @click="$router.push({path: 'userCenter', query: {'type': 1}})">
                        </div>
                      <span v-if="item.proList&&closeMkPro.indexOf(item.content)==-1">
                        <div class="greyList" v-for="(pro,j) in item.proList" :key="'prolist'+j">
                          <div class="greyListText1">{{ pro.name }}  <span style="color: #1E81EB;">PRO</span></div>
                          <div class="gretListLine"></div>
                          <div class="greyListText">{{ pro.pro }}</div>
                          <img src="~@/assets/newHome/查看图源.png" alt="" title="查看" @click="initMap(pro.name,`${tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=${item.content}&tk=${tk}&pro=${pro.pro}&vf=0`,item.extent,item.content,pro.pro)"
                               :class="`${!/(2024年)|(区县)/.test(pro.name)?'keyIcon2':'keyIcon_compare'}`"
                               v-if="pro.type=='pro'" style="top: 22px;">
                          <img src="~@/assets/newHome/复制key.png" alt="" title="复制"
                               :class="`${!/(2024年)|(区县)/.test(pro.name)?'keyIcon3':'keyIcon2'}`"
                               v-if="pro.type=='pro'" @click="showCopyPanel(pro.pro,pro.name)">
<!--                          <img name='卷帘' src="~@/assets/RSsserviceManage/对比.png" class="keyIcon_compare"-->
<!--                               v-if="!/(全国)|(区县)|(全球)/.test(pro.name)" title="对比" @click="juanlian(pro)"-->
<!--                               id="qbMainMap">-->

                        </div>
                      </span>
                    </div>
                </div>
                <!-- <div class="keyManage">
                    <div class="keyLine1"></div>
                    <div class="keyLine2"></div>
                    <img src="~@/assets/newHome/调用次数监控.png" alt="" class="keyIcon1" style="width: 50px;left: calc(50% - 25px);">
                    <div class="keyTitle">调用次数监控</div>
                    <img src="~@/assets/newHome/收起详情.png" alt="" class="keyIcon4" v-if="showCount==0" @click="showCount=1">
                    <img src="~@/assets/newHome/展开详情.png" alt="" class="keyIcon4" v-if="showCount==1" @click="showCount=0">
                </div>
                <div v-if="showCount==0">
                    <div class="countText1">今日已使用次数：{{totalNumToday}}/{{ canUseCountToday}}</div>
                    <div class="countWhite">
                        <div class="greyImg" v-if="calendarHover"></div>
                        <img src="~@/assets/newHome/日历.png" alt="" class="countIcon1" @mouseenter="calendarHover=true" @mouseleave="calendarHover = false" @click="calendarShow=true">
                        <img src="~@/assets/newHome/左箭头.png" alt="" class="countIcon2" @click="changeDate(0)" v-if="canLeft">
                        <img src="~@/assets/newHome/左箭头灰.png" alt="" class="countIcon2" v-if="!canLeft">
                        <img src="~@/assets/newHome/右箭头.png" alt="" class="countIcon2" style="left: 370px;" @click="changeDate(1)" v-if="canRight">
                        <img src="~@/assets/newHome/右箭头灰.png" alt="" class="countIcon2" style="left: 370px;"  v-if="!canRight">
                        <div class="countText2">{{year}}年{{month}}月</div>
                        <div class="countCalendar">
                            <div v-for="(item, index) in dayList" :key="index">
                                <div class="countCircle" :class="[index==0 ? 'countCirclespe1':'', index==7||index==16||index==25 ? 'countCirclespe2':'']"  @click="changeColor(index)" v-show="dateCanShow[index]">
                                    <div class="countCircle1" :id="'countCircle' + index"></div>
                                    <div class="countCircle2" :id="'countCircles' + index">{{index+1}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="calendarDialog" v-if="calendarShow">
                            <img src="~@/assets/newHome/日历关闭.png" alt="" class="countIcon3" @click="calendarShow=false">
                            <div :class="year==2024 ? 'calendarYear-s' : 'calendarYear'" @click="changeYear(2024)">2024年</div>
                            <div :class="year==2025 ? 'calendarYear-s' : 'calendarYear'" style="left: 168px;" @click="changeYear(2025)">2025年</div>
                            <div :class="year==2026 ? 'calendarYear-s' : 'calendarYear'" style="left: 236px;" @click="changeYear(2026)">2026年</div>
                            <div class="calendarMonth">
                                <div v-for="(item, index) in monthList" :key="index">
                                    <div  :class="month1==index ? 'calendarMonth1-s' : 'calendarMonth1'" @click="changeMonth(index)">{{index+1}}月</div>
                                </div>
                            </div>
                        </div>
                        <div class="totalStatistics">{{yearSelect}}年{{monthSelect+1}}月{{daySelect}}日总调用次数：<span style="color: #979797 ;">{{ totalNum }}</span><br>
                            各图调用次数如右侧所示
                        </div>
                        <div class="calendarTip">提示:调用次数统计结果可能存在延迟</div>
                        <div class="mkStatistics">
                            <div v-for="(item, index) in mkNumList" :key="index">
                                <div class="mkNum">
                                    <div class="mkNumName">{{ mkNumList[index].name }}<span style="color: #1E81EB;">MK</span></div>
                                    <div class="mkNumCount">{{ mkNumList[index].count }}</div>
                                </div>
                              <span v-if="mkNumList[index].proList&&mkNumList[index].proList.length>0">
                                <div v-for="(itemPro,indexPro) in mkNumList[index].proList" :key="'flowPro'+indexPro" class="mkNum">
                                  <div class="mkNumName">{{ itemPro.name }}<span style="color: #1E81EB;">PRO</span></div>
                                  <div class="mkNumCount">{{ itemPro.count }}</div>
                                </div>
                              </span>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="keyManage">
                  <div class="keyLine1" style="width: 514px;"></div>
                  <div class="keyLine2" style="width: 514px;"></div>
                  <img src="~@/assets/newHome/使用说明书.png" alt="" class="keyIcon1" style="width: 48px;left: calc(50% - 24px);">
                  <div class="keyTitle">使用说明书</div>
                  <img src="~@/assets/newHome/收起详情.png" alt="" class="keyIcon4" v-if="showDescription==0" @click="showDescription=1">
                  <img src="~@/assets/newHome/展开详情.png" alt="" class="keyIcon4" v-if="showDescription==1" @click="showDescription=0">
                </div>
                <div v-if="showDescription==0">
                  <div class="greyDescription">
                    <img src="~@/assets/newHome/说明书pdf.png" alt="" class="desIcon">
                    <img src="~@/assets/newHome/说明书pdf.png" alt="" class="desIcon" style="top: 84px;left: 0px;">
                    <img src="~@/assets/newHome/说明书pdf.png" alt="" class="desIcon" style="top: 0px;left: 579px;">
                    <img src="~@/assets/newHome/说明书pdf.png" alt="" class="desIcon" style="top: 84px;left: 579px;">
                    <div class="desText1">吉林一号切片影像套件<br><span style="opacity: 0.8;">使用说明书(V1.1)</span></div>
                    <div class="desText1"  style="top: 84px;left:51px;">吉林一号切片影像套件移动端工具集SDK<br><span style="opacity: 0.8;">使用说明书(V1.0)</span></div>
                    <div class="desText1"  style="top: 0px;left:630px;">吉林一号切片影像套件Web端工具集SDK<br><span style="opacity: 0.8;">使用说明书(V1.0)</span></div>
                    <div class="desText1"  style="top: 84px;left:630px;">吉林一号核查助手APP<br><span style="opacity: 0.8;">使用说明书(V2.0)</span></div>
                    <div class="desButton" @click="yuedushuoming()">查看</div>
                    <div class="desButton" style="top: 92px;left: 400px;" @click="getIntroction(2)">查看</div>
                    <div class="desButton" style="top: 0px;left:979px;" @click="getIntroction(1)">查看</div>
                    <div class="desButton" style="top: 92px;left:979px;" @click="getIntroction(3)">查看</div>
                  </div>
                </div>
            </div>
            <div class="greyButton" @click="$router.push('/MyRSservice');">返回我的套件</div>
        </div>
        <!-- 申请新的key弹窗 -->
        <div class="shadow" v-if="isShadow==1">
            <div class="shadowContent1">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="isShadow=0">
                <div class="shadowtext1">TK更改确认</div>
                <div class="shadowText2">请您确认：<br><span style="padding-left: 2em;">您请求</span> 更改您的吉林一号影像服务套件
                    <span v-if="itemList.type=='1'">企业版-{{itemList.repSubNam}}</span>
                    <span v-if="itemList.type=='4'">专业版-{{$store.state.subName}}</span>
                    用户TK，一旦更改，您将获得新的TK，同时当前TK将作废失效并且无法恢复，请您确认当前TK未关联您的重要业务。
                    <br><span style="padding-left: 2em;color: #FF4040;">此操作无法撤回</span>，请您务必知悉。</div>
                <div class="shadowButton" @click="$router.push('/');" v-if="!canChangeKey">确认更改 ({{second}}s)</div>
                <div class="shadowButton1" @click="submitKey()" v-if="canChangeKey">确认更改</div>
            </div>
        </div>
        <div class="shadow" v-if="isShadow==2">
            <div class="shadowContent1">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="isShadow=0">
                <div class="shadowtext1">TK更改失败</div>
                <div class="shadowText2" style="text-align: center;top: 150px;">TK每天只能更改一次。</div>
                <div class="shadowButton1" @click="isShadow=0">取消</div>
            </div>
        </div>
        <!--地图弹窗-->
        <div class="text-center" v-if="mapdialog" style="z-index:1001">
        <v-dialog v-model="mapdialog" width="100vw" height="100vh" content-class="mapDialog">
            <v-card
            height="100vh"
            style="position: relative;width: calc(100vw - 8px);padding: 1px;z-index:1001;"
            >
            <!--关闭标签-->
            <img
                style="position: absolute; top: 25px;right:30px;z-index:1; cursor: pointer"
                src="~@/assets/RSsserviceManage/关闭.png"
                height="40"
                width="40"
                @click="mapdialog = false;juanlianOpen=false"
            />
                <!-- <div id="cgmapmk"></div> -->
                <div class="mapdiv">
                    <pl-lazy>
                        <main-map
                        ref="mainmap"
                        :lyrdata="lyrdata"
                        :mapCtrlTools="mapCtrlTools4Use"
                        :mapParams="mapParams"
                        >
                        </main-map>
                    </pl-lazy>
                </div>
            </v-card>
        </v-dialog>
        </div>

        <!-- 卷帘 -->
        <div class="juanlianContent" v-show="juanlianOpen">
            <a-select id="juanlianList1" v-model="leftCompareName" @change='changeMaps("left")' placeholder="请选择影像"
            style="position: fixed;width: 25vw;height: 30px;top: 62px;left: 200px;z-index: 1002; background-color: #2E3338;border:none;">
            <a-select-option v-for="item in dataList" :key="item.value" :value="item.value">{{ item.label }}
            </a-select-option>
            </a-select>
            <a-select id="juanlianList2" v-model="rightCompareName" @change='changeMaps("right")' placeholder="请选择影像"
            style="position: fixed;width: 25vw;height: 30px;top: 62px;right:200px;z-index: 1002; background-color: #2E3338;border:none;">
            <a-select-option v-for="item in dataList" :key="item.value" :value="item.value">{{ item.label }}
            </a-select-option>
            </a-select>
            <!-- <div class="juanlianClose" @click="endCompare()">
            </div> -->
        </div>


        <div class="shadow" v-if="showCopyPanelVisiable" id="keyIconId" data-clipboard-action="copy" :data-clipboard-text="copyUrl">
            <div class="shadowContent1" style="height:670px;top: calc(50% - 335px);">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="showCopyPanelVisiable=false">
                <div class="shadowtext1" style="width:100%;left:unset;">{{copyPanelMkName}}</div>
                <div class="tips" style="top: 108px;">使用场景1：基于 Openlayers / QGIS / Leaflet 等</div>
                <div class="address" style="top:150px">
                    <div class="mark"><span class="allKey">https://api.jl1mall.com/getMap/{z}/{x}/{-y}?mk=<span class="key">{{copyPanelMk}}</span>&tk=<span class="key">{{tk}}</span></span></div>
                    <div class="copyBtn" @click="copyAddress(1)">复制地址</div>
                </div>
                <div class="tips" style="top:260px;">使用场景2：基于 Cesium</div>
                <div class="address" style="top:303px">
                    <div class="mark"><span class="allKey">https://api.jl1mall.com/getMap/{z}/{x}/{reverseY}?mk=<span class="key">{{copyPanelMk}}</span>&tk=<span class="key">{{tk}}</span></span></div>
                    <div class="copyBtn" @click="copyAddress(2)">复制地址</div>
                </div>
                <div class="tips" style="top:410px;">使用场景3：基于 Mapbox</div>
                <div class="address" style="top:450px">
                    <div class="mark"><span class="allKey">https://api.jl1mall.com/getMap/{z}/{x}/{y}?mk=<span class="key">{{copyPanelMk}}</span>&tk=<span class="key">{{tk}}</span></span></div>
                    <div class="copyBtn" @click="copyAddress(3)">复制地址</div>
                </div>
                <a class="readMore" @click="readMoreKey">详细了解Key的用法 ></a>

            </div>
        </div>
    </div>
</template>

<script>
import MainMap from '@/components/Maps/MainMap'
import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
import Clipboard from 'clipboard';
import { transformExtent } from 'ol/proj'
export default {
  components: {
    MainMap
  },
  data() {
    return {
        isShadow:0,
        canChangeKey:false,
        second: 5,
        timer:"",
        screenHeight:1920,
        showDescription:0,
        showKey:0,
        oldKey:0,
        showCount:0,
        freebackShow:true,
        repositoryId:"",
        mapdialog:false,
        tk: "",
        copyPanelMk: "",
        copyPanelMkName: "",
        copyUrl: "",

        tkList:[],
        timeList:[],
        tkName:"",
        mkList:[],
        calendarShow:false,
        calendarHover:false,
        year:2024,
        //这个月份显示01-12
        month:1,
        //这个月份显示从0-11
        month1:0,
        day:1,
        dayList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
        monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
        list:[],
        sevenList:[],
        canLeft:true,
        canRight:true,
        dateCanShow:[],
        yearSelect:2024,
        monthSelect:0,
        daySelect:1,
        totalNum:0,
        mkNumList:[],
        canUseCount:100000,
        canUseCountToday:40000,
        totalNumToday:0,
        createTime: "",

        showCopyPanelVisiable:false,

        //地图
        tileBaseUrl:'https://api.jl1mall.com',
        // tileBaseUrl:'https://mt.jl1mall.com',
        lyrdata: [
            {
                lyrType:"Tile",
                srcType:"XYZ",
                mUrl:`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=${this.tk}&vf=0`,
                mTitle:"全球一张图",
                mName:"全球一张图",
                mExtent:['73.5013','3.4065','135.0961','53.5632'],
                mVisible:true
            },
            {
                lyrType:"Tile",
                srcType:"XYZ",
                mUrl:"",
                mTitle:"",
                mName:"",
                mExtent:[],
                mVisible:true
            },
            // {
            //     lyrType: "Tile",
            //     srcType: "XYZ",
            //     mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
            //     mTitle: "文字标注",
            //     mName: "文字标注",
            //     mVisible: false
            // }
            // {
            //     lyrType: "MapboxVectorLayer",
            //     srcType: "MapboxVectorLayer",
            //     // mUrl: "https://earth.jl1.cn/symboltile/placetile",
            //     mTitle: "文字标注",
            //     mName: "文字标注",
            //     mVisible: true
            // }
        ],
        mapCtrlTools4Use: [2],
        mapParams: {
            projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
            center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
            // center:[142.85524, 43.61710], //地图初始化时的中心坐标【基于4326坐标系】
            // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
            minZoom:1, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
            maxZoom:18, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
            zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
        },
        //卷帘参数
        juanlianOpen: false,
        leftCompareName: '',//卷帘左侧select的值
        rightCompareName: '',//卷帘右侧select的值
        dataList: [],// 卷帘select的选项数据列表
        //关闭的Pro的Mk列表
        closeMkPro:[],
        itemList:{},

    };
  },
  created() {

  },
mounted() {
    this.toPageTop()
    this.getHeight()
    window.onresize = () =>{
         return (()=>{
           this.screenHeight = document.documentElement.clientWidth || document.body.clientWidth
         })()
       }
    this.itemList= this.$store.state.item
    console.log("itemList:>>>>>",this.itemList)
    this.getTk()
    this.getMk()
    this.getDate()
    this.createTime= this.$store.state.createTime
    console.log(this.createTime);
    // this.createTime=this.createTime.substring(0,10)
    bus.$off('loadGisMapRunOver')
    bus.$on('loadGisMapRunOver',()=>{
        if (this.juanlianOpen) {
            this.$refs.mainmap.toggleJL(this.leftCompareName,this.rightCompareName)
        }
    })
    this.getDateData1(this.repositoryId,this.year,this.month1+1)
  },
    methods: {
        addCloseMkPro(id){
          let index = this.closeMkPro.indexOf(id);
          if (index !== -1) {
            this.closeMkPro.splice(index, 1);
          } else {
            this.closeMkPro.push(id);
          }
        },
        decCloseMkPro(id){
          let index = this.closeMkPro.indexOf(id);
          if (index !== -1) {
            this.closeMkPro.splice(index, 1);
          } else {
            this.closeMkPro.push(id);
          }
        },
        getKey() {
            return localStorage.getItem("token");
        },
        getHeight(){
            let windowWidth = document.documentElement.clientWidth || document.body.clientWidth
            let freebackBlueId = document.getElementById("freebackBlueId")
            freebackBlueId.style.width=windowWidth+"px"
            let naviContentId = document.getElementById("naviContentId")
            naviContentId.style.width=windowWidth+"px"
        },
        toPageTop(){
          document.getElementById('topbar').scrollIntoView({ behavior: "instant"});
        },
        daojishiOn(){
            this.$nextTick(() => {
            this.timer = setInterval(this.daojishi, 1000);
        });
        },
        daojishi(){
            if(this.second<=0){
                this.canChangeKey=true
                clearInterval(this.timer);
            }else{
                this.second--
            }
        },
        submitKey(){
            this.repositoryId= this.$store.state.repositoryId
            let inputForm = new FormData();
            inputForm.append("repositoryId",this.repositoryId);
            this.axios.post("/tilesapi/tiles/repository/makeNewRepositoryTk",inputForm, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    console.log(res)
                    if(res.data.code==200){
                        this.isShadow=0
                        this.getTk()
                    }else if(res.data.msg=='TK每日最多修改一次！'){
                        this.isShadow=2
                    }
                })
        },
        initMap(title,url,bbox,mk,pro){
            // console.log(title,url,bbox,mk)
            bbox=bbox?bbox.split(',').map(Number):[]

            this.lyrdata=[
                {
                    lyrType:"Tile",
                    srcType:"XYZ",
                    mUrl:url,
                    mTitle:title,
                    mName:title,
                    mExtent:bbox,
                    mVisible:true
                },
            ]

            // 修改原预览图层，不是全国一张图的展示底图和矢量边框,通过接口查询
            if(pro){
                let param=new FormData();
                param.append('program_id',pro)
                this.axios.post("/map_service_back/program/getProgramShape", param)
                .then((res) => {
                    if(res.data.code==200){
                        let shape = res.data.shape
                        this.lyrdata.push({
                            lyrType:"lVector",
                            srcType:"Vector",
                            mUrl:shape,
                            mTitle:"边框",
                            mName:"边框",
                            mVisible:true
                        })
                        this.mapdialog=true
                    }
                })
            }
            else if (!/(全球)|(年度)/.test(title)) {
                this.axios.get(`/tilesapi/tiles/mk/queryMkShape?mk=${mk}&repositoryId=${this.repositoryId}`,{
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res) => {
                    if(res.data.code==200){
                        let shape = res.data.msg
                        // let geom = JSON.parse(shape)
                        // this.lyrdata.unshift({
                        //     lyrType:"Tile",
                        //     srcType:"XYZ",
                        //     mUrl:`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=${this.tk}&vf=0`,
                        //     mTitle:"全球一张图",
                        //     mName:"全球一张图",
                        //     mExtent:['73.5013','3.4065','135.0961','53.5632'],
                        //     mVisible:true
                        // })
                        this.lyrdata.push({
                            lyrType:"lVector",
                            srcType:"Vector",
                            mUrl:shape,
                            mTitle:"边框",
                            mName:"边框",
                            mVisible:true
                        })
                        this.mapdialog=true
                    }
                })
            }
            else {
                this.mapdialog=true
            }
        },
        juanlian(item){
            this.leftCompareName=''
            this.rightCompareName=''
            this.leftCompareName=item.name

            this.lyrdata=[];
            this.dataList=[]
            this.mkList.forEach(v=>{
                if (v.extent==item.extent) {
                    let url=`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=${v.content}&tk=${this.tk}&vf=0`
                    this.dataList.push({
                        value: v.name,
                        label: v.name,
                        url: url
                    })
                    let bbox=item.extent.split(',').map(Number)
                    let temp={
                        lyrType:"Tile",
                        srcType:"XYZ",
                        mUrl:url,
                        mTitle:v.name,
                        mName:v.name,
                        mExtent:bbox,
                        mVisible:false
                    }
                    this.lyrdata.push(temp)
                    if (v.name!=this.leftCompareName&&!this.rightCompareName) {
                        this.rightCompareName=v.name
                    }
                }
            })
            this.lyrdata.unshift({
                lyrType:"Tile",
                srcType:"XYZ",
                mUrl:`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=${this.tk}&vf=0`,
                mTitle:"全球一张图",
                mName:"全球一张图",
                mExtent:['73.5013','3.4065','135.0961','53.5632'],
                mVisible:true
            })
            this.lyrdata.push({
                lyrType:"lVector",
                srcType:"Vector",
                mUrl:item.shape,
                mTitle:"边框",
                mName:"边框",
                mVisible:true
            })
            this.axios.get(`/tilesapi/tiles/mk/queryMkShape?mk=${item.content}&repositoryId=${this.repositoryId}`,{
                headers: {
                Authorization: "Bearer " + this.getKey(),
                },
            }).then((res) => {
                if(res.data.code==200){
                    let shape = res.data.msg
                    this.lyrdata.push({
                        lyrType:"lVector",
                        srcType:"Vector",
                        mUrl:shape,
                        mTitle:"边框",
                        mName:"边框",
                        mVisible:true
                    })
                    this.juanlianOpen=true
                    this.mapdialog=true
                }
            })
        },
        changeMaps(position) {
            if (position == 'left') {
                for (let i = 0; i < this.dataList.length; i++) {
                    if (this.leftCompareName == this.dataList[i].label) {
                        let newUrl = this.dataList[i].url
                        this.$refs.mainmap.JLLeftlyr.getSource().setUrl(newUrl)
                        // this.$refs.mainmap.swipe.layers[0].layer.getSource().setUrl(newUrl)
                        break;
                    }
                }
            } else if (position == 'right') {
                for (let i = 0; i < this.dataList.length; i++) {
                    if (this.rightCompareName == this.dataList[i].label) {
                        let newUrl = this.dataList[i].url
                        this.$refs.mainmap.JLRightlyr.getSource().setUrl(newUrl)
                        // this.$refs.mainmap.swipe.layers[1].layer.getSource().setUrl(newUrl)
                        break;
                    }
                }
            } else {
                console.log("有问题")
            }
        },
        showCopyPanel(mk,mkName) {
            this.copyPanelMk=mk
            this.copyPanelMkName=mkName
            this.showCopyPanelVisiable = true
        },
        // type 1场景1 2场景2 3场景3
        copyAddress(type) {
            let y = ''
            switch (type) {
                case 1:
                    y='{-y}'
                    break;
                case 2:
                    y='{reverseY}'
                    break;
                case 3:
                    y='{y}'
                    break;
                default:
                    y='{-y}'
                    break;
            }
            this.copyUrl = `https://api.jl1mall.com/getMap/{z}/{x}/${y}?mk=${this.copyPanelMk}&tk=${this.tk}`
            this.copy()
        },
        copy(){
            var clipboard = new Clipboard("#keyIconId")
            clipboard.on("success", e => {
            alert("复制链接成功！");
            clipboard.destroy()
            })
            clipboard.on("error", e => {
                alert("复制失败！");
                // 释放内存
                clipboard.destroy()
            })
        },
        getIntroction(i){
            if(i==1){
                window.open("https://files.jl1mall.com/tiles/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C/%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%E5%88%87%E7%89%87%E5%BD%B1%E5%83%8F%E5%A5%97%E4%BB%B6Web%E7%AB%AF%E5%B7%A5%E5%85%B7%E9%9B%86SDK_V1.0.0_%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf")
            }else if(i==2){
                window.open("https://files.jl1mall.com/tiles/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C/%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%E5%88%87%E7%89%87%E5%BD%B1%E5%83%8F%E5%A5%97%E4%BB%B6%E7%A7%BB%E5%8A%A8%E7%AB%AF%E5%B7%A5%E5%85%B7%E9%9B%86SDK_V1.0.0_%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf")
            }else if(i==3){
                window.open("https://files.jl1mall.com/tiles/使用手册/吉林一号核查助手APP_V2.0.0_使用说明书.pdf")
            }else if(i==4){
                window.open("https://files.jl1mall.com/tiles/sdk/吉林一号切片影像套件Web端工具集SDK_V1.0.0.zip")
            }else if(i==5){
                window.open("https://files.jl1mall.com/tiles/sdk/吉林一号切片影像套件移动端工具集SDK_V1.0.0.zip")
            }
        },
        readMoreKey(){
            window.open("https://files.jl1mall.com/tiles/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C/%E5%90%89%E6%9E%97%E4%B8%80%E5%8F%B7%E5%88%87%E7%89%87%E5%BD%B1%E5%83%8F%E5%A5%97%E4%BB%B6%E7%AC%AC%E4%B8%89%E6%96%B9%E5%B7%A5%E5%85%B7%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E9%80%9F%E8%AF%BB.pdf")
        },
        getTk(){
            console.log(this.$store.state.repositoryId);
            this.repositoryId= this.$store.state.repositoryId
            let inputForm = new FormData();
            inputForm.append("repositoryId",this.repositoryId);
            this.axios.post("/tilesapi/tiles/repository/queryRepositoryTkList",inputForm, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    let data = res.data.data
                    this.tkName = data[0].name
                    this.tk = data[0].keyList[0].content
                    for(let i=1;i<data.length;i++){
                        this.tkList[i-1]=data[i]
                        let time =data[i].keyList[0].date
                        let year = time.substring(0,4)
                        let month = time.substring(5,7)
                        let day = time.substring(8,10)
                        this.timeList[i-1] = year + '年'+month+'月'+day+'日'
                    }
                })
        },
        getMk(){
            this.repositoryId= this.$store.state.repositoryId
            console.log(this.$store.state.repositoryId);

            let inputForm = new FormData();
            inputForm.append("repositoryId",this.repositoryId);
            this.axios.post("/tilesapi/tiles/repository/queryRepositoryMkProList",inputForm, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    let data = res.data.data
                    this.mkList=data
                    window.scrollTop = 0;
                })
        },
        //判断当前选中日期的总访问次数
        getTodayTotalNum(day){
            if(this.tkName=='体验版'){
                if(this.sevenList[day]==0){
                    this.canUseCount=40000
                }else if(this.sevenList[day]==1){
                    this.canUseCount=100000
                }else if(this.sevenList[day]==2){
                    this.canUseCount=3000000
                }
            }else if(this.tkName=='企业版'){
                this.canUseCount=3000000
            }else{
              if(this.sevenList[day]==2){
                this.canUseCount=3000000
              }
              else {
                this.canUseCountToday=500000
              }

            }

        },
        //初始化获取当前日期
        getDate(){
            var date = new Date()
            this.year = date.getFullYear() // 获取年
            var month = date.getMonth() + 1 // 获取月
            this.month1=date.getMonth()
            this.day = date.getDate() // 获取日
            if(month<10){
                this.month="0"+month
            }else{
                this.month = month
            }
            if(this.year==2024 && this.month1==0){
                this.canLeft=false
            }else if(this.year==2026 && this.month1==11){
                this.canRight=false
            }else{
                this.canRight=true
                this.canLeft=true
            }
            this.dateShowJudge()
            this.yearSelect=this.year
            this.monthSelect=this.month1
            this.daySelect=this.day

        },
        //判断每个月展示多少天
        dateShowJudge(){
            for(let i=0;i<31;i++){
                this.dateCanShow[i]=true
            }
            if((this.year==2025||this.year==2026)&&this.month1==1){
                this.dateCanShow[28]=false
                this.dateCanShow[29]=false
            }
            if(this.year==2024&&this.month1==1){
                this.dateCanShow[29]=false
            }
            if(this.month1==1||this.month1==3||this.month1==5||this.month1==8||this.month1==10){
                this.dateCanShow[30]=false
            }
        },
        //左右箭头改变年月
        changeDate(i){
            if(i==0){
                if(this.month1==0){
                    this.year--
                    this.month1=11
                }else{
                    this.month1--
                }
            }else if(i==1){
                if(this.month1==11){
                    this.year++
                    this.month1=0
                }else{
                    this.month1++
                }
            }
            if(this.year==2024 && this.month1==0){
                this.canLeft=false
            }else if(this.year==2026 && this.month1==11){
                this.canRight=false
            }else{
                this.canRight=true
                this.canLeft=true
            }
            this.getEmpty()
            this.dateShowJudge()
            this.getDateData(this.repositoryId,this.year,this.month1+1)

        },
        //日历选择年份
        changeYear(i){
            this.year=i
            this.getEmpty()
            this.dateShowJudge()
            this.getDateData(this.repositoryId,this.year,this.month1+1)
        },
        //日历选择月份
        changeMonth(index){
            this.month1=index
            if(this.year==2024 && this.month1==0){
                this.canLeft=false
            }else if(this.year==2026 && this.month1==11){
                this.canRight=false
            }else{
                this.canRight=true
                this.canLeft=true
            }
            this.getEmpty()
            this.dateShowJudge()
            this.getDateData(this.repositoryId,this.year,this.month1+1)
        },
        //选择某个日期,变成全部蓝色圆
        changeColor(index){
            this.yearSelect=this.year
            this.monthSelect=this.month1
            this.daySelect=index+1
            this.day = index+1
            this.getTodayTotalNum(index)
            this.geryExist()
            let countCircleNum = document.getElementById("countCircle" + index);
            let countCircleNums = document.getElementById("countCircles" + index);
            console.log(countCircleNum.style.background)
            if(countCircleNum.style.background=='conic-gradient(rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)'){
                countCircleNum.style.background="conic-gradient(#1E81EB  0% 100%)"
            }
            countCircleNums.style.backgroundColor="#1E81EB"
            countCircleNums.style.color="#fff"
            this.totalNum=this.list[index]
            this.getMkData(this.repositoryId,this.yearSelect,this.monthSelect+1,this.daySelect)

        },
        //判断灰色圆环是否显示
        geryExist(){
            let createYear=this.createTime.substring(0,4)
            let createMonth=""
            let createMonth1=this.createTime.substring(5,6)
            let createMonth2=this.createTime.substring(6,7)
            if(createMonth1==0||createMonth1=='0'){
              createMonth=createMonth2
            }else{
              createMonth=this.createTime.substring(5,7)
            }
            let createDay=""
            let createDay1=this.createTime.substring(8,9)
            let createDay2=this.createTime.substring(9,10)
            if(createDay1==0||createDay1=='0'){
              createDay=createDay2
            }else{
              createDay=this.createTime.substring(8,10)
            }
            let createTime = createYear+"-"+createMonth+"-"+ createDay
            var date = new Date()
            let year = date.getFullYear() // 获取年
            let month=date.getMonth()+1//获取月
            let day = date.getDate() // 获取日
            let list =[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            if(this.list.length>1){
              for(let i=0;i<this.list.length;i++){
                  list[i]=this.list[i]
              }
            }
            let count = 40000
            if(this.tkName=='体验版'){
                if(this.sevenList[this.daySelect-1]==0){
                    this.canUseCount=40000
                }else if(this.sevenList[this.daySelect-1]==1){
                    this.canUseCount=100000
                }else if(this.sevenList[this.daySelect-1]==2){
                    this.canUseCount=3000000
                }
                for(let i=0;i<this.list.length;i++){
                    if(this.sevenList[i]==0){
                        count=40000
                    }else if(this.sevenList[i]==1){
                        count=100000
                    }else if(this.sevenList[i]==2){
                        count=3000000
                    }
                    if(list[i]<count){
                        list[i]=(list[i]/count)*100
                    }else{
                        list[i]=100
                    }
                }
            }else if(this.tkName=='企业版'){
                this.canUseCount=3000000
                for(let i=0;i<this.list.length;i++){
                    count = 3000000
                    if(list[i]<count){
                        list[i]=(list[i]/count)*100
                    }else{
                        list[i]=100
                    }
                }
            }else{
              if(this.sevenList[this.daySelect-1]==2){
                this.canUseCountToday=3000000
              }
              else {
                this.canUseCountToday=500000
              }

                for(let i=0;i<this.list.length;i++){
                    count = 500000
                    if(list[i]<count){
                        list[i]=(list[i]/count)*100
                    }else{
                        list[i]=100
                    }
                }
            }
            let dayFor=""
            for(let i=0;i<31;i++){
                let countCircleNum = document.getElementById("countCircle" + i);
                let countCircleNums = document.getElementById("countCircles" + i);
                let today = year+"-"+month+"-"+day
                let month1 = this.month1+1
                let j=i+1
                dayFor=this.year+"-"+month1+"-"+ j
                var a1 = Date.parse(new Date(dayFor));
                var a2 = Date.parse(new Date(today));
                var a3 = Date.parse(new Date(createTime));
                var dayCount1 = parseInt((a1-a2)/ (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
                var dayCount2= parseInt((a3-a1)/ (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
                if(dayCount1<=0&&dayCount2<=0){
                  if(list[i]==100){
                    countCircleNum.style.background="conic-gradient(#49C2FF 0% 100%)"
                  }else{
                    countCircleNum.style.background="conic-gradient(#49C2FF  0% "+list[i]+"%,#EAEAEA "+list[i]+"% 100%)"
                  }
                  countCircleNums.style.backgroundColor="#fff"
                  countCircleNums.style.color="#3A3A3A"
                }else{
                  countCircleNum.style.background="conic-gradient(#fff  0% 100%)"
                  countCircleNums.style.backgroundColor="#fff"
                  countCircleNums.style.color="#3A3A3A"
                }
            }
        },
        //切换月份时圆环先变成空白
        getEmpty(){
            for(let i=0;i<31;i++){
                let countCircleNum = document.getElementById("countCircle" + i);
                let countCircleNums = document.getElementById("countCircles" + i);
                countCircleNum.style.background="conic-gradient(#fff  0% 100%)"
                countCircleNums.style.backgroundColor="#fff"
                countCircleNums.style.color="#3A3A3A"
            }
        },
        //按日期请求数据
        getDateData(repositoryId,year,month){
            let inputForm = new FormData();
            inputForm.append("repositoryId",repositoryId);
            inputForm.append("year",year);
            inputForm.append("month",month);
            this.axios.post("/tilesapi/tiles/flow/queryUserPerDayFlow",inputForm, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    let data = res.data.data
                   this.list=data.userUseDayFlowList
                   this.sevenList=data.userRepDateList
                   if(this.yearSelect==year&&this.month1==this.monthSelect){
                        this.totalNum=this.list[this.daySelect-1]
                   }
                   this.geryExist()
                   let index = this.daySelect-1
                    if(this.yearSelect==this.year&&this.monthSelect==this.month1){
                        // let countCircleNum = document.getElementById("countCircle" + index);
                        let countCircleNums = document.getElementById("countCircles" + index);
                        // countCircleNum.style.background="conic-gradient(#1E81EB  0% 100%)"
                        countCircleNums.style.backgroundColor="#1E81EB"
                        countCircleNums.style.color="#fff"
                    }
                })
        },
        getDateData1(repositoryId,year,month){
            console.log(repositoryId);
            let inputForm = new FormData();
            inputForm.append("repositoryId",repositoryId);
            inputForm.append("year",year);
            inputForm.append("month",month);
            this.axios.post("/tilesapi/tiles/flow/queryUserPerDayFlow",inputForm, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    let data = res.data.data
                    console.log(res.data);
                    this.list=data.userUseDayFlowList
                    this.sevenList=data.userRepDateList
                    console.log("this.tkName",this.tkName)
                    if(this.tkName=='体验版'){
                        var date = new Date()
                        var day = date.getDate()
                        if(this.sevenList[day-1]==0){
                            this.canUseCountToday=40000
                        }else if(this.sevenList[day-1]==1){
                            this.canUseCountToday=100000
                        }else if(this.sevenList[day-1]==2){
                            this.canUseCountToday=3000000
                        }
                    }else if(this.tkName=='企业版'){
                        this.canUseCountToday=3000000
                    }
                    else{
                      if(this.sevenList[day-1]==4){
                        this.canUseCountToday=500000
                      }
                      else {
                        this.canUseCountToday=3000000
                      }
                    }
                    this.getTodayTotalNum(this.day-1)
                    this.totalNumToday=this.list[this.daySelect-1]
                    this.totalNum=this.list[this.daySelect-1]
                    this.geryExist()
                    this.changeColor(this.day-1)
                })
        },
        //按日期请求MK流量统计
        getMkData(repositoryId,year,month,day){
            let inputForm = new FormData();
            inputForm.append("repositoryId",repositoryId);
            inputForm.append("year",year);
            inputForm.append("month",month);
            inputForm.append("day",day);
            this.axios.post("/tilesapi/tiles/flow/queryUserPerMkFlowPro",inputForm, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                    console.log(res.data);
                    let data = res.data.data
                    this.mkNumList=data
                })
        },
        yuedushuoming(){
            window.open("https://files.jl1mall.com/使用手册/吉林一号切片影像套件服务V1.21使用说明书.pdf")
        }
    },
    watch:{
        showKey: function (val, oldVal) {
            if(val==0){
                let greyBasisId = document.getElementById("greyBasisId")
                greyBasisId.style.height="auto"
            }else if(val==1){
                if(this.showCount==0){
                    let greyBasisId = document.getElementById("greyBasisId")
                    greyBasisId.style.height="1500px"
                }else if(this.showCount==1){
                    if(this.showDescription==0){
                        let greyBasisId = document.getElementById("greyBasisId")
                        greyBasisId.style.height="1500px"
                    }else{
                        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
                        let h = windowHeight - 236
                        let greyBasisId = document.getElementById("greyBasisId")
                        greyBasisId.style.height= h +"px"
                    }

                }
            }

        },
        showCount: function (val, oldVal) {
           if(val==0){
                if(this.showKey==0){
                    let greyBasisId = document.getElementById("greyBasisId")
                    greyBasisId.style.height="auto"
                }else if(this.showKey==1){
                    let greyBasisId = document.getElementById("greyBasisId")
                    greyBasisId.style.height="1500px"
                }
           }else if(val==1){
                if(this.showKey==0){
                    let greyBasisId = document.getElementById("greyBasisId")
                    greyBasisId.style.height="auto"
                }else if(this.showKey==1){
                    if(this.showDescription==0){
                        let greyBasisId = document.getElementById("greyBasisId")
                        greyBasisId.style.height="1500px"
                    }else{
                        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
                        let h = windowHeight - 236
                        let greyBasisId = document.getElementById("greyBasisId")
                        greyBasisId.style.height= h +"px"
                    }

                }
           }

        },
        showDescription: function (val, oldVal) {
           if(val==0){
                if(this.showKey==0){
                    let greyBasisId = document.getElementById("greyBasisId")
                    greyBasisId.style.height="auto"
                }else if(this.showKey==1){
                    let greyBasisId = document.getElementById("greyBasisId")
                    greyBasisId.style.height="1500px"
                }
           }else if(val==1){
                if(this.showKey==0){
                    let greyBasisId = document.getElementById("greyBasisId")
                    greyBasisId.style.height="auto"
                }else if(this.showKey==1){
                    let greyBasisId = document.getElementById("greyBasisId")
                    greyBasisId.style.height="1500px"

                }
           }

        },
        oldKey:function(val,oldVal){
            let greyListId = document.getElementById("greyListId")
            if(val==0){
                greyListId.style.height="auto"
            }else if(val==1){
                greyListId.style.height= "54px"

            }
        },
        month1:function(val,oldVal){
            val++
            if(val<10){
                this.month="0"+val
            }else{
                this.month = val
            }
        },
        screenHeight(val){
            let freebackBlueId = document.getElementById("freebackBlueId")
            let naviContentId = document.getElementById("naviContentId")
            freebackBlueId.style.width=val+"px"
            naviContentId.style.width=val+"px"
       }
    }
};
</script>

<style lang="scss" scoped>
  .bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.freeback{
    position: relative;
    width: 100%;
    height: 40px;
    background: #0066CC;
}
.freebackBlue{
    position: absolute;
    width: 1920px;
    height: 40px;
}
.freebackText{
    position: absolute;
    left:50%;
    transform:translate(-50%,0);
    width: 800px;
    height:40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height:40px;
    text-align: center;
    z-index: 1;
}
.freebackClose{
    position: absolute;
    width: 14px;
    height: 14px;
    right: 50px;
    top: 13px;
    cursor: pointer;
}
.navi{
    position: relative;
    width: 100%;
    height: 40px;
    background: #F5F5F6;
}
.naviContent{
    position: absolute;
    width: 1920px;
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 40px;
    padding-left: 120px;
}
.greyBasis{
    position: relative;
    width: 100%;
    height: auto;
    background-color: #fff;
    overflow: hidden;
}
.basisTitle{
    position: absolute;
    top: 43px;
    left: calc(50% - 201px);
    width: 402px;
    height: 42px;
    z-index: 1;
}
.basisText1{
    position: absolute;
    top: 53px;
    left: calc(50% - 400px);
    width:800px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
    z-index: 2;
}
.greyContent{
    margin-top: 50px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height:auto;
    background: #F7F7F7;
    border-radius: 16px;
    padding-bottom: 20px;
    margin-bottom: 50px;
    overflow: hidden;
}
.keyManage{
    position: relative;
    margin-left: calc(50% - 560px);
    width: 1120px;
    height: 48px;
    /* background-color: pink; */
    margin-top: 75px;
    margin-bottom: 50px;
}
.greyList{
    position: relative;
    margin-left: calc(50% - 560px);
    margin-bottom: 10px;
    width: 1120px;
    height: 54px;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
}
.greyListBlock{
    position: relative;
    margin-top: 17px;
    margin-left: 222px;
    margin-bottom: 17px;
    width: 600px;
    height: 20px;
}
.greyList-s{
    position: relative;
    margin-left: calc(50% - 560px);
    margin-bottom: 80px;
    width: 1120px;
    height: 54px;
    background: #FFFFFF;
    border-radius: 8px;
}
.greyListText1{
    position: absolute;
    right: 749px;
    top: 17px;
    width:400px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #3A3A3A;
line-height: 20px;
text-align: right;
}
.gretListLine{
    position: absolute;
    top: 14px;
    left: 400px;
    width: 2px;
    height: 26px;
    background-color:#979797 ;
    opacity: 0.5;
}
.greyListText{
    position: absolute;
    top: 17px;
    left: 430px;
    width: 483px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #777777;
line-height: 20px;
}
.greyListText-s{
    position: relative;
    margin-top: 13px;
    margin-bottom: 20px;
    margin-left: 422px;
    width: 690px;
    height: 20px;
}
.greyListText-s1{
    position: relative;
    margin-bottom: 20px;
    margin-left: 422px;
    width: 690px;
    height: 20px;
}
.greyListText1-s{
    position: absolute;
    left: 8px;
    width: 280px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #B8B8B8;
    line-height: 20px;
}
.greyListLine{
    position: absolute;
    top: 10px;
    left: 0;
    width: 280px;
    height: 1px;
    background:  #B8B8B8;
}
.greyListText2-s{
    position: absolute;
    left: 330px;
    width: 150px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #777777;
line-height: 20px;
}
.keyLine1{
    position: absolute;
    top: 24px;
    left: 0;
    width: 508px;
    height: 1px;
    border-bottom: 1px dashed #979797;
}
.keyLine2{
    position: absolute;
    top: 24px;
    right: 0;
    width: 508px;
    height: 1px;
    border-bottom: 1px dashed #979797;
}
.keyIcon1{
    position: absolute;
    top: 0;
    left: calc(50% - 40px);
    width: 80px;
    height: 48px;
}
.keyIcon2{
    position: absolute;
    top: 19px;
    right: 55px;
    cursor: pointer;
}
.keyIcon3{
    position: absolute;
    top: 19px;
    right: 100px;
    cursor: pointer;
}
.keyIcon_compare{
    position: absolute;
    top: 20px;
    right: 15px;
    cursor: pointer;
}
.keyIcon4{
position: absolute;
top: 13px;
right: 23px;
cursor: pointer;
}
.keyIcon5{
  position: absolute;
  width: 25px;
  height: 25px;
  top: 15px;
  right: 143px;
  cursor: pointer;
}
.greyDescription{
    position: relative;
    margin-left: calc(50% - 560px);
    margin-top: 10px;
    width: 1120px;
    height: 150px;
}
.desIcon{
    position: absolute;
    top: 0;
    left: 0;
}
.desText1{
    position: absolute;
    top: 0;
    left: 51px;
    width: 290px;
height: 44px;
font-size: 16px;
font-family: PingFangSC-Regular;
font-weight: 400;
color: #3A3A3A;
line-height: 22px;
}
.desButton{
    position: absolute;
    top: 0;
    left: 400px;
    width: 72px;
height: 36px;
border-radius: 8px;
border: 1px solid #0066CC;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 600;
color: #0066CC;
line-height: 36px;
text-align: center;
cursor: pointer;
}
.keyTitle{
    position: absolute;
    top: 13px;
    left: calc(50% - 60px);
    width: 120px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 22px;
text-align: center;
}
.countText1{
    margin-left: calc(50% - 400px);
    margin-bottom: 25px;
    width: 800px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 20px;
    text-align: center;
}
.countWhite{
    position: relative;
    margin-left: calc(50% - 560px);
    margin-bottom: 80px;
    width: 1120px;
height: 520px;
background: #FFFFFF;
border-radius: 8px;
}
.greyImg{
    position: absolute;
    top: 30px;
    left: 67px;
    width: 41px;
    height: 41px;
    background: #F7F7F7;
    border-radius: 50%;
    cursor: pointer;
}
.countIcon1{
    position: absolute;
    top: 41px;
    left: 79px;
    cursor: pointer;
}
.countIcon3{
    position: absolute;
    width: 20px;
    height: 20px;
    top: 5px;
    right: 5px;
    cursor: pointer;
}
.countIcon2{
    position: absolute;
    top: 41px;
    left: 250px;
    cursor: pointer;
}
.countText2{
    position: absolute;
    top: 38px;
    left: 271px;
    width: 90px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
    text-align: center;
}
.countCalendar{
    position: absolute;
    width: 476px;
    height: 224px;
    top: 103px;
    left: 68px;
}
.countCircle{
    position: relative;
    float: left;
    margin-left: 10px;
    margin-bottom: 11px;
    width: 44px;
    height: 44px;
    cursor: pointer;
}
.countCirclespe1{
    position: relative;
    float: left;
    margin-left: 108px;
    margin-bottom: 11px;
    width: 44px;
    height: 44px;
    cursor: pointer;
}
.countCirclespe2{
    position: relative;
    float: left;
    margin-left: 0px;
    margin-bottom: 11px;
    width: 44px;
    height: 44px;
    cursor: pointer;
}
.countCircle1{
    position: absolute;
    top: 0;
    left: 0;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #fff;
}
.countCircle1-s{
    position: absolute;
    top: 0;
    left: 0;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: conic-gradient(#1E81EB  0% 100%);
}
.countCircle2{
    position: absolute;
    top: 4px;
    left: 4px;
    width: 36px;
    height: 36px;
    background-color: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
}
.countCircle2-s{
    position: absolute;
    top: 4px;
    left: 4px;
    width: 36px;
    height: 36px;
    background-color: #1E81EB;
    border-radius: 50%;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
}
.calendarDialog{
    position: absolute;
    width: 400px;
    height: 150px;
    background: #FFFFFF;
    box-shadow: 1px 1px 5px 2px rgba(0,0,0,0.2);
    top: 75px;
    left: 79px;
    z-index: 1;
}
.calendarDialog{
    position: absolute;
    width: 400px;
    height: 150px;
    background: #FFFFFF;
    box-shadow: 1px 1px 5px 2px rgba(0,0,0,0.2);
    top: 75px;
    left: 79px;
    z-index: 1;
}
.calendarYear{
    position: absolute;
    width: 64px;
    height: 30px;
    background: #fff;
    top: 15px;
    left: 100px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #3A3A3A;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
}
.calendarYear-s{
    position: absolute;
    width: 64px;
    height: 30px;
    background: #fff;
    top: 15px;
    left: 100px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #49C2FF;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
}
.calendarYear:hover{
    background: #F7F7F7;
}
.calendarMonth{
    position: absolute;
    width: 330px;
    height: 64px;
    top: 65px;
    left: 43px;
}
.calendarMonth1{
    float: left;
    background: #fff;
    margin-right: 15px;
    margin-bottom: 12px;
    width: 40px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
}
.calendarMonth1-s{
    float: left;
    background: #fff;
    margin-right: 15px;
    margin-bottom: 12px;
    width: 40px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #49C2FF;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
}
.calendarMonth1:hover{
    background: #F7F7F7;

}
.totalStatistics{
    position: absolute;
    top: 342px;
    left: 79px;
    width: 480px;
    height: 42px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
    line-height: 22px;
}
.calendarTip{
    position: absolute;
   bottom: 60px;
    left: 79px;
    width: 480px;
    height:auto;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3a3a3a;
    line-height: 22px;
}
.mkStatistics{
    top: 40px;
    left: 674px;
    position: absolute;
    height: 420px;
    width: 400px;
    overflow-y: auto;
    overflow-x: hidden;
}
.mkNum{
    position: relative;
    width: 500px;
    height: 20px;
    margin-bottom: 20px;
}
.mkNumName{
    position: absolute;
    left: 0;
    top: 0;
    width: 300px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 20px;
}
.mkNumCount{
    position: absolute;
    left: 300px;
    width: 100px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 20px;
}
.greyButton{
    margin-left: calc(50% - 75px);
    width: 150px;
    height: 40px;
    background: #1E81EB;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 125px;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent1{
    position: fixed;
    top: calc(50% - 200px);
    left: calc(50% - 400px);
    width: 800px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 12px;
    .tips{
        position: absolute;
        left: 74px;
        font-size: 14px;
        // font-family: PingFangSC-Regular, PingFang SC;
        // font-weight: 400;
        color: #000000;
        line-height: 30px;
    }
    .address{
        position: absolute;
        left: 74px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 30px;
        width: 660px;
        height: 100px;
        display: flex;
        align-items: center;
        .mark{
            width: 536px;
            height: 100px;
            background: #F2F2F2;
            border-radius: 8px;
            padding: 5px 15px;
            .allKey{
                width: 500px;
                display: block;
                word-wrap: break-word;
                .key{
                    color: #0066CC;
                }
            }
        }
        .copyBtn{
            width: 96px;
            height: 40px;
            background: #0066CC;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #FFFFFF;
            margin-left: 20px;
            cursor: pointer;
        }
    }
    .readMore{
        position:absolute;
        top: 580px;
        left: 74px;
        font-size: 14px;
        line-height: 30px;
    }
}
.shadowClose{
position: absolute;
width: 40px;
height: 40px;
top: 0px;
right: -55px;
cursor: pointer;
}
.shadowtext1{
    position: absolute;
    top: 50px;
    left: calc(50% - 60px);
    width: 120px;
height: 25px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 25px;
text-align: center;
}
.shadowText2{
    position: absolute;
    top: 108px;
    left: 74px;
    width: 660px;
height: 150px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #000000;
line-height: 30px;
}
.shadowButton{
    position: absolute;
    top: 307px;
    left: calc(50% - 75px);
    width: 150px;
    height: 40px;
    background: #CCCCCC;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
}
.shadowButton1{
    position: absolute;
    top: 307px;
    left: calc(50% - 75px);
    width: 150px;
    height: 40px;
    background: #0066CC;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
}

::v-deep .mapDialog{
    overflow-y: unset;
    z-index: 1001;
}
::v-deep .theme--light.v-card{
    background: rgba(238,238,238);
}
/* #cgmapmk { */
#cgmap {

    align-items: center;
    display: flex;
    justify-content: center;

    transform-origin: center center;
    width: 1280px;
    position: absolute;
    /* width: calc(100% - 10px); */
    /* height: calc(100% - 10px); */
    /* left: 5px; */
    /* top: 5px; */
}
.mapdiv{
    position: absolute;
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    left: 5px;
    top: 5px;
}
::v-deep .v-dialog:not(.v-dialog--fullscreen){
    max-height: unset;
}
::v-deep .v-dialog__content,
::v-deep.v-dialog__content--active{
    z-index: 1001 !important;
}
::v-deep .ant-select-selection{
    background: #2e3338;
    color: white;
}
::v-deep .ant-select-arrow{
    color: white;
}
  </style>
